import type { ResourceKey } from '../types';

export const RESOURCE_KEYS: ResourceKey[] = [
    'food',
    'fish',
    'wood',
    'planks',
    'stone',
    'bricks',
    'charcoal',
    'ironOre',
    'ironIngots',
    'fiber',
    'clothRope',
    'leather',
    'weapons',
    'goldOre',
    'coins',
    'tools',
];
